import AOS from 'aos'
import 'aos/dist/aos.css'

document.addEventListener('DOMContentLoaded', () => {
  AOS.init({
    once: true,
    duration: 800
  })
})